/* @flow */

/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import omit from 'lodash.omit';
import getConfig from 'next/config';


import {
  setMarginStatus as setMarginStatusAction,
  fetchMarginAccount as fetchMarginAccountAction,
  setMarginAccountMaxBorrowable as setMarginAccountMaxBorrowableAction,
  setMarginAutoRepay as setMarginAutoRepayAction,
  setMarginStopLimitOrOCOTab as setMarginStopLimitOrOCOTabAction,
  fetchMarginCoeff as fetchMarginCoeffAction,
} from '../../actions/actionsSet/margin';
import { fetchAllUserAssets as fetchAllUserAssetsAction } from '../../actions/actionsSet/assetService';
import {
  verifyToken as verifyTokenRequest,
} from '../../actions/actionsSet/authcenter';
import withI18n from '../../utils/withI18n';
import TabbedOrderForms from '../../components/OrderForms/TabbedOrderForms';
import TabbedOrderFormsMargin from '../../components/OrderForms/TabbedOrderFormsMargin';
import isServer from '../../utils/isServer';
import { setItem } from '../../utils/localStorage';

const {
  publicRuntimeConfig: {
    enableMargin,
  },
} = getConfig();


type Props = {
  isLoggedIn: bool,
  canOpenMarginAccount: bool,
  isMarginAccountOpened: bool,
  theme?: string,
  i18n: Object,
  base: string,
  pair: Array<any>,
  locale: string,
  userInfo: Object,
  allUserAssets: Array<any>,
  marginAssets: Array<any>,
  marginAccount: Object,
  marginSymbols: Object,
  marginLevel: string,
  marginCoeff: Object,
  marginStatus: boolean,
  marginBorrow_BUY: boolean,
  marginBorrow_SELL: boolean,
  marginStopLimitOrOCOTab: boolean,
  isMarginPair: bool,
  userKYCInfo: Object,
  fetchMaxBorrowAmount: Function,
  setMarginAccountMaxBorrowable: Function,
  setMarginAutoRepay: Function,
  verifyToken: Function,
  fetchMarginCoeff: Function
}

type State={
  tip:string,
  color:string,
  fetched: boolean,
}

const mapStateToProps = ({
  isLoggedIn,
  marginSymbols,
  allUserAssets,
  marginAssets,
  marginAccount,
  marginStatus,
  marginBorrow_BUY,
  marginBorrow_SELL,
  marginAutoRepay,
  marginStopLimitOrOCOTab,
  marginCoeff,
  marginAccount: { marginLevel },
  isMarginPair,
  userInfo,
  userKYCInfo,
}) => ({
  isLoggedIn,
  marginSymbols,
  allUserAssets,
  marginAssets,
  marginAccount,
  marginStatus,
  marginBorrow_BUY,
  marginBorrow_SELL,
  marginAutoRepay,
  marginStopLimitOrOCOTab,
  marginCoeff,
  marginLevel,
  isMarginPair,
  userInfo,
  userKYCInfo,
});
const mapDispatchToProps = ({
  setMarginStatus: setMarginStatusAction,
  fetchMarginAccount: fetchMarginAccountAction,
  fetchAllUserAssets: fetchAllUserAssetsAction,
  setMarginAccountMaxBorrowable: setMarginAccountMaxBorrowableAction,
  setMarginAutoRepay: setMarginAutoRepayAction,
  setMarginStopLimitOrOCOTab: setMarginStopLimitOrOCOTabAction,
  verifyToken: verifyTokenRequest,
  fetchMarginCoeff: fetchMarginCoeffAction,
});

export default @connect(mapStateToProps, mapDispatchToProps)

@withI18n
class OrderFormContainer extends React.Component<Props, State> {
  static defaultProps = {
    isLoggedIn: false,
    i18n: {},
    base: '',
    pair: ['', ''],
    locale: 'en',
    userInfo: {},
    userKYCInfo: {},
  };

  static getDerivedStateFromProps({ userInfo: { fetched, isExistMarginAccount, subUser } }:Props) {
    if (!isServer && fetched) {
      if (!isExistMarginAccount || subUser) setItem(window.localStorage, 'margin.status', false);
    }
    return { fetched };
  }

  render() {
    const {
      i18n, locale, base, pair,
      userInfo: { isKYCValidated },
      isMarginPair,
      userKYCInfo,
      fetchMarginCoeff,
    } = this.props;
    const { fetched } = this.state;

    return (
      <Fragment>
        { enableMargin && isMarginPair ?
          <TabbedOrderFormsMargin
            fetched={fetched}
            userKYCInfo={userKYCInfo}
            isKYCValidated={isKYCValidated}
            fetchMarginCoeff={fetchMarginCoeff}
            {...omit(this.props, ['flex', 'wrap'])}
          />
          :
          <TabbedOrderForms i18n={i18n} locale={locale} base={base} pair={pair} />
            }
      </Fragment>
    );
  }
}
